module.exports = __webpack_public_path__ + "assets/disclaimerIcon.632b8a67.svg";